class AcademyVideoPlayer extends HTMLElement {
  connectedCallback() {
    const trigger = this.querySelector('[data-video-src]');
    if (!trigger || trigger.dataset.videoReady === 'true') return;

    trigger.dataset.videoReady = 'true';
    trigger.addEventListener('click', () => {
      const source = new URL(trigger.dataset.videoSrc);
      source.searchParams.set('autoplay', '1');

      const iframe = document.createElement('iframe');
      iframe.src = source.toString();
      iframe.title = trigger.dataset.videoTitle;
      iframe.allow = 'autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.allowFullscreen = true;

      trigger.replaceWith(iframe);
    }, { once: true });
  }
}

if (!customElements.get('academy-video-player')) {
  customElements.define('academy-video-player', AcademyVideoPlayer);
}
